var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3155_71150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 7.5V13.3333",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 7.08268C5.87077 7.08268 7.08333 5.87012 7.08333 4.37435C7.08333 2.87858 5.87077 1.66602 4.375 1.66602C2.87923 1.66602 1.66667 2.87858 1.66667 4.37435C1.66667 5.87012 2.87923 7.08268 4.375 7.08268Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.334C5.54738 18.334 6.66667 17.2147 6.66667 15.834C6.66667 14.4533 5.54738 13.334 4.16667 13.334C2.78595 13.334 1.66667 14.4533 1.66667 15.834C1.66667 17.2147 2.78595 18.334 4.16667 18.334Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 18.334C17.214 18.334 18.3333 17.2147 18.3333 15.834C18.3333 14.4533 17.214 13.334 15.8333 13.334C14.4526 13.334 13.3333 14.4533 13.3333 15.834C13.3333 17.2147 14.4526 18.334 15.8333 18.334Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.275 7.5C4.65 8.95833 5.98333 10.0417 7.55833 10.0333L10.4167 10.025C11.1167 10.025 11.775 10.1667 12.3833 10.4167",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3155_71150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDepartment);
export default __webpack_public_path__ + "static/media/activeDepartment.990e0c5a4666dbefd6bbc19a2d1b3f71.svg";
export { ForwardRef as ReactComponent };